module.exports = new __parcel__URL__("battlepass_assign_button.3dcd7213.png").toString();